module.exports = __webpack_public_path__ + "media/stylesheets/opensans700-6437d5f4c14e01aaf4801aef3909151b.woff";